import {EMPLOYEE_LIST} from '../testing/TestingEmployeeDataSH26'

let list = EMPLOYEE_LIST;


// helper functions

function FilterJobs(type) {
    return list.filter(function (employee) {
        return employee.employeeStatus === type;
    })
}

// reducers

export function SearchReducer(state = "search", action) {

    switch (action.type) {
        case 'employee/SEARCH': {
            let returnList = []
            let employees = list;
            for (const employee in employees) {
                if (employees[employee].name.toUpperCase().includes(action.term.toUpperCase())) {
                    returnList.push(employees[employee]);
                } else if (employees[employee].id.includes(action.term)) {
                    returnList.push(employees[employee]);
                }
            }

            if (returnList.length === 0) {
                const message = "'" + action.term + "' didn't match any employees";
                return message;
            }
            
            return returnList;
        }
        default:
            return [];
    }
}

export function SortReducer(state, action, jobType) {
    let EmployeeList = list;
    switch (action.type) {
        case 'employeeSort/SORT_NEW':
            EmployeeList.sort((employee1, employee2) =>
                (employee1.dates.dateStarted > employee2.dates.dateStarted) ? 1 :
                    (employee1.dates.dateStarted < employee2.dates.dateStarted) ? -1 : 0);
            return EmployeeList;
        case 'employeeSort/SORT_OLD':
            EmployeeList.sort((employee1, employee2) =>
                (employee1.dates.dateStarted < employee2.dates.dateStarted) ? 1 :
                    (employee1.dates.dateStarted > employee2.dates.dateStarted) ? -1 : 0);
            return EmployeeList;
        case 'employeeSort/SORT_AZ':
            EmployeeList.sort((employee1, employee2) =>
                (employee1.name > employee2.name) ? 1 : (employee1.name < employee2.name) ? -1 : 0);
            return EmployeeList;
        default:
            return EmployeeList;
    }
}


export function FilterReducer(state = "none", action) {
    switch (action.type) {
        case 'employee/FILTER': {
            const filter = action.filterBy;
            let returnList = []
            let employees = list;
            for (const employee in employees) {
                if (employees[employee].employeeStatus === filter) {
                    returnList.push(employees[employee]);
                }
            }
            if (returnList.length === 0) {
                const message = "filtering by'" + filter + "' didn't match any employees";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}

export function addEmployees(values) {
    const date = new Date();
    //if (values !== undefined) {
    //  const newEmployee = {
    //    id: "00001",
    //  name: values.name,
    // email: values.email,
    // phoneNumber: values.phone,
    // dates: {
    //   dateStarted: date.getDay() + "-" + (date.getMonth()+1) + "-" + date.getFullYear(),
    // dateEnded: null,
    //},
    //jobs: [],
    //popup: "Current Employee"
    //};
    //list.push(newEmployee);
    //}
    
    return list;

}